module.exports = __webpack_public_path__ + "right.1BGTHvtq.svg";